// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rg7R","col":"styles_col__15G9Y","actions":"styles_actions__b_E_X","conflict":"styles_conflict__2h4Yt"};